import * as tslib_1 from "tslib";
import getFavoriteCategorySuggestions from '../actions/helpers/getFavoriteCategorySuggestions';
import getFavoriteFolderSuggestions from '../actions/helpers/getFavoriteFolderSuggestions';
import getFavoriteGroupSuggestions from '../actions/helpers/getFavoriteGroupSuggestions';
import getFavoritePeopleSuggestions from '../actions/helpers/getFavoritePeopleSuggestions';
import getFavoriteSearchSuggestions from '../actions/helpers/getFavoriteSearchSuggestions';
import datapoints from '../datapoints';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { logUsage } from 'owa-analytics';
import { CategoryIcon } from 'owa-categories';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { lazyAddFavoriteFolder, showFindFavoritesPicker, lazyHandleToggleFavoritePersonaError, lazyAddFavoriteGroup, } from 'owa-mail-favorites-store';
import { lazyAddFavoriteCategory } from 'owa-favorites';
import addFavoriteSearch from 'owa-mail-favorites-store/lib/actions/v1/addFavoriteSearch';
import addFavoritePersona from 'owa-mail-favorites-store/lib/actions/v1/people/addFavoritePersona';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { setFindText } from 'owa-mail-find-favorites-store';
import { findFavoritesStore } from 'owa-mail-find-favorites-store';
import { resetFocus } from 'owa-mail-focus-manager';
import { getCustomIcon } from 'owa-mail-folder-forest-actions';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { BasePickerListBelow, } from 'office-ui-fabric-react/lib/Pickers';
var styles = require('./FavoritesPicker.scss');
var FavoritesPickerInternal = /** @class */ (function (_super) {
    tslib_1.__extends(FavoritesPickerInternal, _super);
    function FavoritesPickerInternal(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Overrides base onInputBlur to be able to hide entire component
         * if the input loses focus without any suggestions visible.
         */
        _this.onInputBlur = function (ev) {
            if (!_this.state.suggestionsVisible) {
                showFindFavoritesPicker(false);
            }
        };
        _this.onInputBlur = _this.onInputBlur.bind(_this);
        return _this;
    }
    return FavoritesPickerInternal;
}(BasePickerListBelow));
export { FavoritesPickerInternal };
var FavoritesPicker = /** @class */ (function (_super) {
    tslib_1.__extends(FavoritesPicker, _super);
    function FavoritesPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The is the callback for when a user selects a suggestion from the
         * picker.
         * @param item The item selected from the picker
         */
        _this.onItemSelected = function (item) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, id, type, suggestionType, _a, addFavoriteFolder, personaType, addFavoriteCategory, addFavoriteGroup;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = item.data, id = item.id, type = item.type;
                        suggestionType = type;
                        _a = suggestionType;
                        switch (_a) {
                            case 0 /* Folder */: return [3 /*break*/, 1];
                            case 1 /* Persona */: return [3 /*break*/, 3];
                            case 2 /* Search */: return [3 /*break*/, 4];
                            case 3 /* Category */: return [3 /*break*/, 5];
                            case 4 /* Group */: return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 9];
                    case 1: return [4 /*yield*/, lazyAddFavoriteFolder.import()];
                    case 2:
                        addFavoriteFolder = _b.sent();
                        addFavoriteFolder(id, 'FavoritesPicker');
                        return [3 /*break*/, 9];
                    case 3:
                        personaType = data;
                        addFavoritePersona(undefined, personaType.EmailAddress.EmailAddress, personaType.DisplayName, 'FavoritesPicker').catch(function (e) { return lazyHandleToggleFavoritePersonaError.importAndExecute(e); });
                        return [3 /*break*/, 9];
                    case 4:
                        addFavoriteSearch(data, 'FavoritesPicker');
                        return [3 /*break*/, 9];
                    case 5: return [4 /*yield*/, lazyAddFavoriteCategory.import()];
                    case 6:
                        addFavoriteCategory = _b.sent();
                        addFavoriteCategory(id, 'FavoritesPicker');
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, lazyAddFavoriteGroup.import()];
                    case 8:
                        addFavoriteGroup = _b.sent();
                        addFavoriteGroup(id, data, 'FavoritesPicker');
                        return [3 /*break*/, 9];
                    case 9:
                        /**
                         * Hide the favorites picker and reset focus.
                         */
                        showFindFavoritesPicker(false);
                        resetFocus();
                        logUsage(datapoints.addFavoriteFromPicker.datapoint.name, datapoints.addFavoriteFromPicker.datapoint.customData(findFavoritesStore.findText.length, suggestionType));
                        return [2 /*return*/, item];
                }
            });
        }); };
        return _this;
    }
    FavoritesPicker.prototype.componentDidMount = function () {
        this.picker.focusInput();
    };
    FavoritesPicker.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.favoritesPickerContainer, tabIndex: -1 },
            React.createElement(FavoritesPickerInternal, { className: styles.favoritesPicker, componentRef: function (picker) {
                    return (_this.picker = picker);
                }, inputProps: {
                    placeholder: strings.searchForFavoriteText,
                }, onDismiss: function () { return _this.dismissFavoritesPicker(); }, onEmptyInputFocus: function () { return _this.onEmptyInputFocus(); }, onItemSelected: function (item) { return _this.onItemSelected(item); }, onRenderSuggestionsItem: function (item) {
                    return _this.onRenderSuggestionsItem(item);
                }, onRenderItem: function () { return _this.onRenderItem(); }, onResolveSuggestions: function (findText) { return _this.onFindTextChanged(findText); }, pickerSuggestionsProps: {
                    className: styles.favoritesPickerSuggestions,
                    noResultsFoundText: strings.noFavoritesFoundText,
                    suggestionsItemClassName: styles.favoritesPickerSuggestionsItem,
                } })));
    };
    /**
     * This function dismisses the picker.
     */
    FavoritesPicker.prototype.dismissFavoritesPicker = function () {
        showFindFavoritesPicker(false);
    };
    /**
     * This function is called when the input first gets focused in order
     * to provide an initial list of suggestions.
     */
    FavoritesPicker.prototype.onEmptyInputFocus = function () {
        return this.onFindTextChanged('');
    };
    /**
     * This function both sets findText in the findFavoritesStore (to maintain
     * store's fidelity) and retrieves matching suggestions.
     * @param findText The text in the picker
     */
    FavoritesPicker.prototype.onFindTextChanged = function (findText) {
        /**
         * Defensive check to ensure findText is non-null. Bug #26271 outlines
         * minimal cases in which this value is somehow null.
         */
        if (findText === null) {
            findText = '';
        }
        setFindText(findText);
        return this.getFavoriteSuggestions(findText);
    };
    /**
     * This function is used by the BasePicker to render a suggestion in the
     * picker.
     * @param item The suggestion to be rendered
     */
    FavoritesPicker.prototype.onRenderSuggestionsItem = function (item) {
        return React.createElement("div", null, this.renderFavoriteSuggestion(item.id, item.type, item.data));
    };
    /**
     * The typical use case of a Fabric picker is to input text, provide the user
     * with suggestions, allow them to select a suggestion, and then show their
     * selection within the picker. Because we're taking the user's selection and
     * immediately performing an action with it, there's no opportunity to render
     * a selected suggestion. However, OUFR BasePicker throws an exception without
     * this prop (even though it's optional).
     */
    FavoritesPicker.prototype.onRenderItem = function () {
        return null;
    };
    /**
     * This is a helper function that retrieves a list of matching suggestions
     * based on the input provided to the picker.
     * @param findText The text in the picker
     */
    FavoritesPicker.prototype.getFavoriteSuggestions = function (findText) {
        var isRoamingFavoritesAPISupported = isControlFeatureEnabled('tri-favorites-roaming');
        var favoriteFolderSuggestions = getFavoriteFolderSuggestions(findText);
        var favoritePeopleSuggestions;
        var favoriteGroupSuggestions;
        if (isRoamingFavoritesAPISupported) {
            // VSO 26190, 26191: [Prime]Support favorite Persona, Search and Category type
            favoritePeopleSuggestions = [];
            favoriteGroupSuggestions = isMailFeatureEnabled('grp')
                ? getFavoriteGroupSuggestions(findText)
                : [];
        }
        else {
            favoritePeopleSuggestions = getFavoritePeopleSuggestions(findText);
            favoriteGroupSuggestions = [];
        }
        var favoriteSearchSuggestions = isMailFeatureEnabled('tri-favoriteSearch')
            ? getFavoriteSearchSuggestions(findText)
            : [];
        var favoriteCategorySuggestions = isControlFeatureEnabled('tri-categories-advanced')
            ? getFavoriteCategorySuggestions(findText)
            : [];
        var favoriteSuggestions = favoritePeopleSuggestions.concat(favoriteFolderSuggestions, favoriteSearchSuggestions, favoriteCategorySuggestions, favoriteGroupSuggestions);
        logUsage(datapoints.showFavoriteSuggestions.datapoint.name, datapoints.showFavoriteSuggestions.datapoint.customData(findText.length, favoritePeopleSuggestions.length, favoriteFolderSuggestions.length, favoriteSearchSuggestions.length, favoriteCategorySuggestions.length, favoriteGroupSuggestions.length));
        return favoriteSuggestions;
    };
    /**
     * This is a helper render function that calls into another helper render
     * function based on the selected suggestion's type.
     */
    FavoritesPicker.prototype.renderFavoriteSuggestion = function (id, type, data) {
        switch (type) {
            case 0 /* Folder */:
                return this.renderFavoriteFolderSuggestion(id, data);
            case 1 /* Persona */:
                return this.renderFavoritePersonaSuggestion(id, data);
            case 2 /* Search */:
                return this.renderFavoriteSearchSuggestion(id, data);
            case 3 /* Category */:
                return this.renderFavoriteCategorySuggestion(id, data);
            case 4 /* Group */:
                return this.renderFavoriteGroupSuggestion(id, data);
        }
        return null;
    };
    /**
     * This function is used to render a category suggestion.
     */
    FavoritesPicker.prototype.renderFavoriteCategorySuggestion = function (id, name) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(CategoryIcon, { categoryName: name, iconClassName: styles.favoriteIcon }),
            React.createElement("span", { className: styles.suggestionDisplayName }, name)));
    };
    /**
     * This function is used to render a search suggestion.
     */
    FavoritesPicker.prototype.renderFavoriteSearchSuggestion = function (id, data) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon, { className: styles.favoriteIcon, iconName: "Search" /* Search */ }),
            React.createElement("span", { className: styles.suggestionDisplayName }, data)));
    };
    /**
     * This function is used to render a person suggestion.
     */
    FavoritesPicker.prototype.renderFavoritePersonaSuggestion = function (id, data) {
        var personaType = data;
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(PersonaControl, { className: styles.persona, name: personaType.EmailAddress.Name, emailAddress: personaType.EmailAddress.EmailAddress, size: PersonaSize.size24 }),
            React.createElement("span", { className: styles.suggestionDisplayName }, personaType.EmailAddress.Name)));
    };
    /**
     * This function is used to render a folder suggestion.
     */
    FavoritesPicker.prototype.renderFavoriteFolderSuggestion = function (id, data) {
        var folderIcon = getCustomIcon(id, true /* showNonSpecialFolderIcon */);
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon, { className: styles.favoriteIcon, iconName: folderIcon }),
            React.createElement("span", { className: styles.suggestionDisplayName }, data)));
    };
    /**
     * This function is used to render a Group suggestion.
     */
    FavoritesPicker.prototype.renderFavoriteGroupSuggestion = function (id, name) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon, { className: styles.favoriteIcon, iconName: "People" /* People */ }),
            React.createElement("span", { className: styles.suggestionDisplayName }, name)));
    };
    FavoritesPicker = tslib_1.__decorate([
        observer
    ], FavoritesPicker);
    return FavoritesPicker;
}(React.Component));
export default FavoritesPicker;
//# sourceMappingURL=FavoritesPicker.js.map